import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { ICompany } from 'src/app/interfaces/company';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { HttpHeaders } from '@angular/common/http';
import { IParentTerm } from 'src/app/interfaces/parent-term';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';

@Component({
  selector: 'app-course-list-search',
  templateUrl: './course-list-search.component.html',
  styleUrls: ['./course-list-search.component.css']
})
export class CourseListSearchComponent implements OnInit {
  param: any;
  personInfo: any;
  errObject: any;
  isOwner: boolean;
  form: FormGroup;
  errors = new Array();
  isUpdate: boolean;
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;
  companyList: ICompany[];
  branchList: IBranch[];
  coursePatternList = [];
  parrentTermList: IParentTerm[];
  courseTypeList: any;
  courseStatusList: any[];
  termInfoList: any[];
  yearList = [];

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private eduPackageService: EducationPackageService,
    private calendatService: CalendarService,
    private levelInfoService: LevelInfoService,
    private bidService: BIDService,
    private cidService: CIDService,
    private branchService: BranchService,
    private parrentTermService: ParrentTermService,
    private termInfoService: TermInfoService,
    private companyService: CompanyService,
    private staticValueService: StaticValueService,
    public dialogRef: MatDialogRef<CourseListSearchComponent>,
    private courseTypeService: CourseTypeService,
    private holdingService: HoldingService

  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.getEduPackage();
    // this.getCompanyList();
    this.getCourseStatus(true);
    // this.getCourseType();
    this.getYear();
  }

  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [this.isOwner ? this.cidService.getCID() : null, this.isOwner ? Validators.required : null],
      BranchEncryptId: [!this.isOwner ? this.bidService.getBID() : null, this.isOwner ? Validators.required : null],
      PackageId: [null],
      LevelInfoId: [null],
      TermInfoId: [null],
      TermNumber: [null],
      CoursePatternId: [null],
      ParentTermId: [null],
      RoomName: [null],
      CourseStatusId: [null],
      CourseTypeId: [null],
      Year: [null]
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
      else {
        this.getParrentTermList(this.cidService.getCID());
        this.getCourseType(this.cidService.getCID());
      }
    });
  }
  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }
  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  getCourseType(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.courseTypeService.listWithCompany(0, 0, true, false, false, headers).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  setValueCourseTypeToChildren(e: MatSelect) {
    this.coursePatternList = this.courseTypeList.filter(function (item) {
      return item.Id == e.value
    })[0].CoursePatternList;
    this.getTermInfo(e.value);
  }

  getYear() {
    this.calendatService.yearList().subscribe(res => {

      res.forEach(item => {
        if (item.Selected) {
          this.form.controls['Year'].setValue(item.Value);
        }
      });
      this.yearList = res;
    });
  }

  getTermInfo(courseTypeId: number) {

    this.errors = new Array();
    var _form = this.form;
    this.termInfoService.list({
      CourseTypeId: courseTypeId,
      Year: this.form.controls['Year'].value,
    }, 0, 0).subscribe(
      res => {
        debugger
        this.termInfoList = res.DataList.filter(function(item){
          return !item.Closed && item.ParentTermId == _form.controls['ParentTermId'].value
        });
      },
      err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
      }
    );
  }

  getCourseStatus(time: boolean) {
    this.staticValueService.courseStatus(time).subscribe(
      res => {

        this.courseStatusList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  // checkOwner() {
  //   this.holdingService.checkOwnerHolding().subscribe(res => {
  //     this.isOwner = res.IsOwner;
  //     if (res.IsOwner)
  //       this.getCompanyList();

  //   });
  // }

  setCid(e: MatSelect) {
    this.getBranchList(e.value);
    this.getCourseType(e.value);
    this.getParrentTermList(e.value);
  }

  getParrentTermList(company) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.parrentTermService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  // submit(data: any) {
  //   var headers = new HttpHeaders({
  //     "Content-Type": "application/json"
  //   })
  //     .append("Authorization", "Bearer " + localStorage.getItem("token"))
  //     .append(
  //       "HID",
  //       localStorage.getItem("holdingCode")
  //         ? localStorage.getItem("holdingCode")
  //         : ""
  //     )
  //     .append(
  //       "CID",
  //       this.form.get('CompanyEncryptId').value
  //     )
  //     .append(
  //       "BID",
  //       data.BranchEncryptId ? data.BranchEncryptId : null
  //     );
  //   this.filter = data;
  //   this.courseService.listByCompany(data, 1, 10, headers).subscribe(res => {
  //     this.dataSource = null;
  //     this.dataSource = res.DataList;
  //     this.paginator.length = res.Total;
  //     this.paginator.pageIndex = 0;
  //     this.paginator.pageSize = 10;
  //   });
  // }

  submit(data: any) {
    this.dialogRef.close({
      header: new HttpHeaders({
        "Content-Type": "application/json"
      })
        .append("Authorization", "Bearer " + localStorage.getItem("token"))
        .append(
          "HID",
          localStorage.getItem("holdingCode")
            ? localStorage.getItem("holdingCode")
            : ""
        )
        .append(
          "CID",
          this.isOwner ? this.form.get('CompanyEncryptId').value : this.cidService.getCID()
        )
        .append(
          "BID",
          this.isOwner ? (data.BranchEncryptId ? data.BranchEncryptId : null) : this.bidService.getBID()
        ),
      filter: data
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
